export default __webpack_public_path__ + "static/media/English2.d31fadfc.png";